import { Box } from "@nulogy/components";
import React from "react";
import styled from "styled-components";

const StyledTag = styled(Box)`
  ${({ theme }) => `
    margin-right: ${theme.sizes.x1};
    padding-left: ${theme.sizes.x1};
    padding-right: ${theme.sizes.x1};
    color: ${theme.colors.darkBlue};
  `}
  background-color: white;
  font-size: 12px;
  display: inline-block;
  border-radius: 20px;
  ${({ tooltipTag, theme }) => {
    if (!tooltipTag) return "";

    return `
      background-color: ${theme.colors.whiteGrey};
      line-height: normal;
    `;
  }}
`;

export default function Tag({ children, ...props }) {
  return (
    <StyledTag className="tag" {...props}>
      {children}
    </StyledTag>
  );
}
